import Check from '@mui/icons-material/Check'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import GroupRemoveIcon from '@mui/icons-material/GroupRemove'
import TuneIcon from '@mui/icons-material/Tune'
import {
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
} from '@mui/material'
import { memo, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { COLOR_VISION, useDayViewSettingsStore } from '../../../contexts/DayViewSettingsStore'

const DayViewSettings = memo(({ className }) => {
  const [anchorMenu, setAnchorMenu] = useState(null)
  const { colorVision, printGroups, setColorVision, setPrintGroups } = useDayViewSettingsStore(
    useShallow((state) => ({
      colorVision: state.colorVision,
      printGroups: state.printGroups,
      setColorVision: state.setColorVision,
      setPrintGroups: state.setPrintGroups,
    }))
  )
  const openSettings = (event) => {
    setAnchorMenu(event.currentTarget)
  }
  const closeSettings = () => {
    setAnchorMenu(null)
  }
  const selectVision = (next) => {
    setColorVision(next)
  }
  const togglePrintGroups = () => {
    setPrintGroups(!printGroups)
  }
  return (
    <div className={`settingsButton noPrint ${className}`}>
      <IconButton onClick={openSettings} color="primary">
        <TuneIcon />
      </IconButton>
      <Menu anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeSettings}>
        <MenuList dense>
          {Object.values(COLOR_VISION).map((c, i) => {
            const isSelected = c.id === colorVision
            return (
              <MenuItem key={i} onClick={() => selectVision(c.id)}>
                <ListItemIcon>{isSelected && <Check />}</ListItemIcon>
                <ListItemText>{c.text}</ListItemText>
              </MenuItem>
            )
          })}

          <Divider />

          <MenuItem onClick={togglePrintGroups}>
            <ListItemIcon>{printGroups ? <GroupRemoveIcon /> : <GroupAddIcon />}</ListItemIcon>
            <ListItemText>{printGroups ? 'Masquer' : 'Afficher'} les groupes</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  )
})
export default DayViewSettings
